import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from "./TranslationContext";
import './AboutUs.css';

export const About = () => {
  const navigate = useNavigate();
  const { t } = useAppTranslation();

  const [author, setAuthor] = useState(null);
  const [authorLoading, setAuthorLoading] = useState(true);
  const [authorError, setAuthorError] = useState(null);


  const [reviews, setReviews] = useState([]);

  const handleClick = () => {
    navigate('/courses');
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch("https://api.eduskill.uz/api/comment-kurs/");
        if (!res.ok) throw new Error("Ошибка загрузки комментариев");

        const data = await res.json();

        // фильтруем только с 5 звёздами и ограничиваем до 5
        const topReviews = data.filter(r => r.stars === 5).slice(0, 5);

        // получаем данные пользователей для каждого комментария
        const reviewsWithUsers = await Promise.all(
          topReviews.map(async (rev) => {
            try {
              const userRes = await fetch(`https://api.eduskill.uz/api/users/${rev.user}/`);
              if (!userRes.ok) throw new Error("Ошибка загрузки пользователя");

              const userData = await userRes.json();
              return {
                ...rev,
                userName: `${userData.first_name || ''} ${userData.last_name || ''}`.trim() || userData.username
              };
            } catch {
              return { ...rev, userName: "Неизвестный пользователь" };
            }
          })
        );

        setReviews(reviewsWithUsers);
      } catch (err) {
        console.error(err);
      }
    };

    fetchReviews();
  }, []);

  // данные автора
  // данные автора
useEffect(() => {
  const controller = new AbortController();

  const fetchAuthor = async () => {
    try {
      setAuthorLoading(true);

      // 1) тянем всех кастом-пользователей без серверного фильтра
      const res = await fetch('https://api.eduskill.uz/api/custom-users/', {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Ошибка загрузки списка профилей');
      const raw = await res.json();

      // 2) нормализуем ответ: [..] или {results:[..]} или одиночный объект
      const list = Array.isArray(raw)
        ? raw
        : (Array.isArray(raw?.results) ? raw.results : (raw ? [raw] : []));

      if (!list.length) throw new Error('Профили не найдены');

      // 3) клиентский фильтр по ilmiy_daraja === 3 (строка/число)
      const filtered = list.filter(p => Number(p?.ilmiy_daraja) === 3);

      // если нет точного совпадения — берём первый как запасной вариант
      const profile = filtered[0] ?? list[0];
      if (!profile) throw new Error('Подходящий профиль не найден');

      // 4) user может быть id или уже объектом
      let userObj = null;
      if (profile.user && typeof profile.user === 'object') {
        userObj = profile.user;
      } else if (profile.user != null) {
        const ures = await fetch(`https://api.eduskill.uz/api/users/${profile.user}/`, {
          signal: controller.signal,
          headers: { Accept: 'application/json' }
        });
        if (!ures.ok) throw new Error('Ошибка загрузки данных пользователя автора');
        userObj = await ures.json();
      } else {
        // если в профиле нет ссылки на user
        throw new Error('У профиля отсутствует поле user');
      }

      const fullName =
        `${userObj?.first_name || ''} ${userObj?.last_name || ''}`.trim() ||
        userObj?.username ||
        '';

      setAuthor({
        id: profile.id,
        fullName,
        patronymic: profile.otasining_ismi ?? '',
        img: profile.img || '/images/author-fallback.jpg',
        description: profile.description ?? '',
        email: userObj?.email ?? '',
        ilmiy_daraja: profile.ilmiy_daraja ?? null,
        til: profile.til ?? null,
      });

      setAuthorError(null);
    } catch (e) {
      if (e.name !== 'AbortError') {
        setAuthorError(e.message || 'Неизвестная ошибка');
      }
    } finally {
      setAuthorLoading(false);
    }
  };

  fetchAuthor();
  return () => controller.abort();
  }, []);

  

  return (
    <div className="about-page">

      {/* Hero-секция */}
      <div className="hero-container">
        <video autoPlay loop muted className="background-video">
          <source src="/videos/about-bg2.mp4" type="video/mp4" />
          Ваш браузер не поддерживает видео.
        </video>
        <div className="video-overlay"></div>
        <div className="hero-content">
          <h1>{t('aboutTitle1')}<span><br />{t('aboutTitle2')}</span></h1>
          <p>{t('aboutSub')}</p>
          <button onClick={handleClick}>{t('footerBtn')}</button>
        </div>
      </div>

      {/* Миссия */}
      <section className="mission">
        <h2>{t('mission')}</h2>
        <div className="mission-image">
          <img src="/images/about-aim.png" alt="" />
        </div>
        <div className="mission-content">
          <p>{t('missionText')}</p>
        </div>
      </section>

      {/* Преимущества */}
      <section className="features">
        <h2>{t('whyWe')}</h2>
        <ul className='features-list'>
          <li className='features-item'>
            <img src="/images/1.gif" alt="" />
            <span>{t('why1')}</span>
          </li>
          <li className='features-item'>
            <img src="/images/2.gif" alt="" />
            <span>{t('why2')}</span>
          </li>
          <li className='features-item'>
            <img src="/images/3.gif" alt="" />
            <span>{t('why3')}</span>
          </li>
          <li className='features-item'>
            <img src="/images/4.gif" alt="" />
            <span>{t('why4')}</span>
          </li>
        </ul>
      </section>

      {/* author */}
      <section className="author">
        <h2>{t('author')}</h2>

        {authorLoading && <p>Загрузка автора…</p>}
        {authorError && <p className="error">{authorError}</p>}

        {!authorLoading && !authorError && author && (
          <div className="author-block">
            <img
              src={author.img || '/images/author-fallback.jpg'}
              alt={author.fullName || 'author'}
              className="author-img"
            />
            <div className="author-content">
              <p className="author-name name-author">
                {author.fullName}
                {author.patronymic ? ` ${author.patronymic}` : ''}
              </p>

              {/* язык — если нужен */}
              {/* <p className="author-lang">{langMap[author.til]}</p> */}

              <p className="author-desc">{author.description}</p>

              {/* email — по желанию */}
              {author.email && <p className="author-email">{author.email}</p>}
            </div>
            
          </div>
        )}
      </section>


      {/* Отзывы */}
      <section className="reviews">
        <h2>{t('reviews')}</h2>
        {reviews.length > 0 ? (
          reviews.map((rev) => (
            <blockquote key={rev.id}>
              {rev.comment} — <strong>{rev.userName}</strong>
            </blockquote>
          ))
        ) : (
          <p>Загрузка отзывов...</p>
        )}
      </section>
    </div>
  );
};
